import { render, staticRenderFns } from "./DocumentosPersonal.vue?vue&type=template&id=6396b0ce&scoped=true"
import script from "./DocumentosPersonal.vue?vue&type=script&lang=js"
export * from "./DocumentosPersonal.vue?vue&type=script&lang=js"
import style0 from "./DocumentosPersonal.vue?vue&type=style&index=0&id=6396b0ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6396b0ce",
  null
  
)

export default component.exports